"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeFormat = void 0;
const dateTimeFormat_1 = require("./dateTimeFormat");
/**
 * formatuje czas do formatu HH:mm:ss
 * @param dt data typu Date
 */
function timeFormat(dt) {
    return dateTimeFormat_1.formatDateFunction['HH:mm:ss'](dt);
}
exports.timeFormat = timeFormat;
//# sourceMappingURL=timeFormat.js.map